import { usePermissions } from '@/hooks/usePermissions';
import { FC, PropsWithChildren, useMemo } from 'react';

export interface Props {
  // if user has any of these permissions, we'll let them access this feature
  renderIfHasPermissions?: string[];
  requireAllPermissions?: boolean;
  renderIfMissingPermissions?: string[];
  placeholderMessage?: any;
}

export const PermissionGuard: FC<PropsWithChildren<Props>> = ({
  renderIfHasPermissions,
  requireAllPermissions = false,
  renderIfMissingPermissions,
  children,
  placeholderMessage = '',
}) => {
  const { userHasAllRequiredPermissions, userHasRequiredPermission } =
    usePermissions();

  const userCanUseFeature = useMemo(() => {
    let result = false;

    if (renderIfHasPermissions?.length) {
      result = requireAllPermissions
        ? userHasAllRequiredPermissions(renderIfHasPermissions)
        : userHasRequiredPermission(renderIfHasPermissions);
    }

    if (renderIfMissingPermissions?.length) {
      const isMissingPermissions = !userHasRequiredPermission(
        renderIfMissingPermissions
      );

      result = isMissingPermissions;
    }

    return result;
  }, [
    userHasAllRequiredPermissions,
    userHasRequiredPermission,
    renderIfHasPermissions,
    requireAllPermissions,
    renderIfMissingPermissions,
  ]);

  if (userCanUseFeature) return children;
  if (placeholderMessage?.length) return placeholderMessage;
  return null;
};
